import observer from 'saddlebag-observer';

export function track<Message>(
  eventName: string,
  fullSchemaName: string,
  message: Message,
  messageOpts?: { store_guid: boolean },
): void {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired: true,
    messageOpts,
  });
}

export function trackBusinessCritical<Message>(
  eventName: string,
  fullSchemaName: string,
  message: Message,
): void {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired: false,
  });
}

export function trackWithGuid<Message>(
  eventName: string,
  fullSchemaName: string,
  message: Message,
  guid: string,
  consentRequired: boolean = true,
): void {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired,
    messageOpts: {
      messageGuid: guid,
    },
  });
}
